import React, { FC } from 'react';
import { Input } from 'reactstrap';

interface FilterProps {
    column: {
        canFilter: boolean;
        render: (filter: string) => void;
    };
}

export const Filter: FC<FilterProps> = ({ column }: any) => {
    return <div style={{ marginTop: 5 }}>{column.canFilter && column.render('Filter')}</div>;
};

interface DefaultColumnFilterProps {
    column: {
        Header: string;
        filterValue: string;
        setFilter: (filter: string | undefined) => void;
        preFilteredRows: {
            length: number;
        };
    };
}

export const DefaultColumnFilter: FC<DefaultColumnFilterProps> = ({ column: { Header, filterValue, setFilter, preFilteredRows } }) => {
    return <Input value={filterValue || ''} onChange={(e) => setFilter(e.target.value || undefined)} placeholder={`Search by ${Header}`} />;
};

interface SelectColumnFilterProps {
    column: {
        filterValue: string;
        setFilter: (filter: string | undefined) => void;
        preFilteredRows: {
            forEach: (callback: (row: { values: { [key: string]: string } }) => void) => void;
        };
        id: string;
    };
}

export const SelectColumnFilter: FC<SelectColumnFilterProps> = ({ column: { filterValue, setFilter, preFilteredRows, id } }) => {
    const options = React.useMemo(() => {
        const ops: any = new Set();
        preFilteredRows.forEach((row) => {
            ops.add(row.values[id]);
        });
        return [...ops.values()];
    }, [id, preFilteredRows]);

    return (
        <select
            id="custom-select"
            className="form-select"
            value={filterValue}
            onChange={(e) => {
                setFilter(e.target.value || undefined);
            }}
        >
            <option value="">All</option>
            {options.map((option) => (
                <option key={option} value={option}>
                    {option}
                </option>
            ))}
        </select>
    );
};
